import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      lg: 1200,
      md: 900,
      sm: 600,
      xl: 1536,
      xs: 0,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          "&:hover": { backgroundColor: "#F2D45E !important" },
          background: "#F2D45E",
          backgroundColor: "#F2D45E",
          color: "#232323",
          fontFamily: "YaroBl",
        },
        outlined: {
          "&:hover": { backgroundColor: "#F2D45E" },
          background: "#F2D45E",
          backgroundColor: "#F2D45E",
          border: "#F2D45E solid 4px",
          color: "#232323",
          fontFamily: "YaroBl",
        },
        root: {
          "&:hover": { backgroundColor: "#60A7DD" },
          background: "#5B9FD2",
          backgroundColor: "#5B9FD2",
          borderRadius: 20,
          color: "#fff",
          fontFamily: "YaroBl",
          fontSize: "1rem",
          paddingLeft: 24,
          paddingRight: 24,
          textTransform: "none",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#F03738", fontFamily: "YaroBl", fontSize: "0.8rem",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "YaroBl",
          color: "#232323",
          fontSize: "1rem",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: "YaroBl",
          fontSize: "1rem",
          fontWeight: "300",
          lineHeight: 25,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "YaroBl",
          fontStyle: "normal",
          fontWeight: "normal",
        },
      },
    },
  },
  palette: {
    common: {
      black: "#232323",
      white: "#FFFFFF",
    },
    contrastThreshold: 3,
    // light or dark
    mode: "light",
    primary: {
      default: "#F2D45E",
      light: "#FFDF63",
      main: "##F2D45E",
    },
    secondary: {
      default: "#60A7DD",
      light: "#A2DFFF",
      main: "#5B9FD2",
    },
    tonalOffset: 0.2,
  },
  // spacing = `${8 * 2}px` = '16px'
  spacing: 8,
  typography: {
    fontFamily: [
      "Courier New",
      "Courier",
      "monospace",
      "YaroBl",
      "YaroBl-Black",
      "YaroBl-Bold",
      "YaroBl-Thin",
    ].join(", "),
  },
});

export default theme;
